<template>
    <transition name="slide">
        <div v-if="isShowContent" id="switch-pen-area" :class="areaPosition" @click="switchPen()"></div>
    </transition>
</template>

<script>
import DEFINE from '../js/painter/define';
import PainterProxy from '../js/painter/proxy';
import { settingStore } from '../js/store/settingStore';
import { TOOLS } from '../js/toolbar/tools';
import { store } from '../store';

export default {
    name: "SwitchPenArea",
    data: function () {
        return {
            show: true,
            store,
            settingStore,
            finalDrawTool: TOOLS.PEN.TOOL
        };
    },
    created() {
        this.show = !store.onlyRead;
    },
    watch: {
        "store.nowTool": {
            handler: function () {
                if (
                    (store.nowTool == TOOLS.PEN.TOOL) ||
                    (store.nowTool == TOOLS.HIGHLIGHTER.TOOL) ||
                    (store.nowTool == TOOLS.ERASER.TOOL)
                ) {
                    this.finalDrawTool = store.nowTool;
                }
            }
        },
        "settingStore.isShowPenChange": {
            handler: function () {
                this.show = !Boolean(settingStore.isShowPenChange);
            }
        }
    },
    methods: {
        toggle() {
            this.show = !this.show;
        },
        switchPen() {
            const proxy = PainterProxy.getInstance();

            if (this.finalDrawTool == store.nowTool) {
                store.nowTool = TOOLS.SELECTION.TOOL;

                proxy.setOperate(DEFINE.OPERATE.SELECTION);
                proxy.changeTool(null);
            } else {
                store.nowTool = this.finalDrawTool;

                switch (this.finalDrawTool) {
                    case TOOLS.PEN.TOOL:
                        proxy.setOperate(DEFINE.OPERATE.PEN);
                        proxy.changeTool(proxy.getDrawTool(DEFINE.OPERATE.PEN));
                        break;
                    case TOOLS.HIGHLIGHTER.TOOL:
                        proxy.setOperate(DEFINE.OPERATE.HIGHLIGHTER);
                        proxy.changeTool(proxy.getDrawTool(DEFINE.OPERATE.HIGHLIGHTER));
                        break;
                    case TOOLS.ERASER.TOOL:
                        proxy.setOperate(DEFINE.OPERATE.ERASER);
                        proxy.changeTool(DEFINE.TOOLS.ERASER);
                        break;
                }
            }
            
            store.setPreviousTool(store.nowTool);
        }
    },
    computed: {
        areaPosition() {
            return { "bottom": settingStore.toolbarPosition > 0 }
        },
        isShowContent() {
            if(store.onlyRead) {
                return false;
            }else {
                return this.show;
            }
        }
    }
};
</script>

<style src="../assets/css/SwitchPenArea.css" scoped>

</style>